<template>
  <b-row class="padding-content">
    <b-col>
      <b-row class="padding-content shadow-sm bg-gray-50">
        <b-col class="text-center">
          <b-row>
            <b-col class="font-weight-bold text-center mb-3">
              Protección Ocular
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Ocular_1.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_ocular.ocular1" name="ocular1"
                     @change="handleChangeOcular($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Ocular_2.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_ocular.ocular2" name="ocular2"
                     @change="handleChangeOcular($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Ocular_3.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_ocular.ocular3" name="ocular3"
                     @change="handleChangeOcular($event)"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <b-row>
            <b-col class="font-weight-bold text-center mb-3">
              Protección Cutánea
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Guantes.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_cutanea.cutanea1"
                     name="cutanea1" @change="handleChangeCutanea($event)"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <b-row>
            <b-col class="font-weight-bold text-center mb-3">
              Protección Respiratoria
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Respiratorio_1.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_respiratoria.respiratoria1"
                     name="respiratoria1" @change="handleChangeRespiratoria($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Respiratorio_2.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_respiratoria.respiratoria2"
                     name="respiratoria2" @change="handleChangeRespiratoria($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Respiratorio_3.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_respiratoria.respiratoria3"
                     name="respiratoria3" @change="handleChangeRespiratoria($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Respiratorio_4.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_respiratoria.respiratoria4"
                     name="respiratoria4" @change="handleChangeRespiratoria($event)"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <b-row>
            <b-col class="font-weight-bold text-center mb-3">
              Botas/Calzado
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Calzado.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_calzado.calzado1"
                     name="calzado1" @change="handleChangeCalzado($event)"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <b-row>
            <b-col class="font-weight-bold text-center mb-3">
              Traje/Ropa
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Traje_1.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_ropa.ropa1" name="ropa1"
                     @change="handleChangeRopa($event)"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img class="navbar-brand-minimized" src="img/Epps/Traje_2.jpg" width="46" height="46" alt="epp"/>
              <input type="checkbox" style="width:27px;height:27px;" v-model="epps.layer_ropa.ropa2" name="ropa2"
                     @change="handleChangeRopa($event)"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <button class="btn btn-secondary float-left" @click="setModalPaso(3)">Anterior</button>
          <button class="btn btn-primary float-right" @click="setModalPaso(5)">Siguiente</button>
          <button class="btn btn-secondary float-right mr-2" @click="setModalVer(false)">Cancelar</button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

  import {mapState, mapActions, mapMutations} from "vuex";

  export default {
    name: "epp",
    computed: {
      ...mapState('pasoapaso', [
        'epps'
      ])
    },
    methods: {
      ...mapActions('pasoapaso', [
        'listarIdiomas',
        'listarTipos',
        'listarEstadoFds'
      ]),
      ...mapMutations('pasoapaso', ['setModalPaso', 'setModalVer']),
      handleChangeOcular: function (e) {
        const name = e.target.name;
        if (this.epps.layer_ocular[name]) {
          Object.keys(this.epps.layer_ocular).map(key => {
            if (key != name) {
              this.epps.layer_ocular[key] = false;
            }
          });
        }
      },
      handleChangeCutanea: function (e) {
        const name = e.target.name;
        if (this.epps.layer_cutanea[name]) {
          Object.keys(this.epps.layer_cutanea).map(key => {
            if (key != name) {
              this.epps.layer_cutanea[key] = false;
            }
          });
        }

      },
      handleChangeRespiratoria: function (e) {
        const name = e.target.name;
        if (this.epps.layer_respiratoria[name]) {
          Object.keys(this.epps.layer_respiratoria).map(key => {
            if (key != name) {
              this.epps.layer_respiratoria[key] = false;
            }
          });
        }
      },
      handleChangeCalzado: function (e) {
        const name = e.target.name;
        if (this.epps.layer_calzado[name]) {
          Object.keys(this.epps.layer_calzado).map(key => {
            if (key != name) {
              this.epps.layer_calzado[key] = false;
            }
          });
        }
      },
      handleChangeRopa: function (e) {
        const name = e.target.name;
        if (this.epps.layer_ropa[name]) {
          Object.keys(this.epps.layer_ropa).map(key => {
            if (key != name) {
              this.epps.layer_ropa[key] = false;
              let data = {
                'layer': this.epps.layer_ropa[key],
                'estado': false
              }
            }
          });
        }
      }
    }
  }
</script>

<style scoped>
.padding-content{
    padding: 20px;
}
</style>
